import { render, staticRenderFns } from "./PayRangeIdentitySummary.vue?vue&type=template&id=a365826e&scoped=true"
import script from "./PayRangeIdentitySummary.vue?vue&type=script&setup=true&lang=js"
export * from "./PayRangeIdentitySummary.vue?vue&type=script&setup=true&lang=js"
import style0 from "./PayRangeIdentitySummary.vue?vue&type=style&index=0&id=a365826e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a365826e",
  null
  
)

export default component.exports